import React from "react"
import Cabecalho from "../Cabecalho"
import { FormularioDadosBancarios } from "./components/FormularioDadosBancarios"

export function DadosBancariosSubconta() {
    return (
        <>
            <Cabecalho pagina="Dados Bancários" />
            <FormularioDadosBancarios />
        </>
    )
}
